(function () {
  'use strict';

  var variantData = [];
  var variantEl = document.getElementById('pdp-variant-data');
  if (variantEl) {
    try { variantData = JSON.parse(variantEl.textContent); } catch(e) {}
  }

  var flavourGradients = {
    'Mango': 'linear-gradient(160deg, #F7C14B, #E07A22)',
    'Blackcurrant': 'linear-gradient(160deg, #6B3A6E, #3A1A3E)'
  };

  function getSelectedOptions() {
    var selected = {};
    document.querySelectorAll('[data-pdp-option-group]').forEach(function (group) {
      var name = group.getAttribute('data-pdp-option-group');
      var active = null;
      group.querySelectorAll('button').forEach(function(b) {
        if (b.style.background === 'rgb(181, 64, 26)' || b.style.backgroundColor === 'rgb(181, 64, 26)' || b.style.background === '#B5401A') {
          active = b;
        }
      });
      if (!active) active = group.querySelector('button');
      if (active) selected[name] = active.getAttribute('data-pdp-option-value');
    });
    return selected;
  }

  function findVariant(selected) {
    var optionNames = [];
    document.querySelectorAll('[data-pdp-option-group]').forEach(function (g) {
      optionNames.push(g.getAttribute('data-pdp-option-group'));
    });
    for (var i = 0; i < variantData.length; i++) {
      var v = variantData[i];
      var match = true;
      for (var j = 0; j < optionNames.length; j++) {
        if (v.options[j] !== selected[optionNames[j]]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateVariant() {
    var selected = getSelectedOptions();
    var variant = findVariant(selected);
    if (!variant) return;

    var idInput = document.querySelector('[data-pdp-variant-id]');
    if (idInput) idInput.value = variant.id;

    var priceEl = document.getElementById('pdp-price-display');
    if (priceEl) {
      var rupees = (variant.price / 100);
      priceEl.textContent = '\u20b9' + rupees.toLocaleString('en-IN');
    }

    var atcBtn = document.getElementById('pdp-atc-submit');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Bag' : 'Resting. Back soon.';
    }

    if (variant.image) {
      var mainImg = document.querySelector('[data-pdp-main-image] img');
      if (mainImg) {
        mainImg.setAttribute('src', variant.image);
        mainImg.setAttribute('srcset', '');
      }
    }

    if (selected['Flavour']) {
      var gallery = document.getElementById('pdp-gallery');
      var grad = flavourGradients[selected['Flavour']];
      if (gallery && grad) gallery.style.background = grad;
    }
  }

  document.querySelectorAll('[data-pdp-option-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('[data-pdp-option-group]');
      if (group) {
        group.querySelectorAll('button').forEach(function (b) {
          b.style.background = 'transparent';
          b.style.color = '#3D2B1A';
          b.style.borderColor = 'rgba(181,64,26,0.2)';
          b.style.borderWidth = '1px';
        });
      }
      this.style.background = '#B5401A';
      this.style.color = '#FFF3DC';
      this.style.borderColor = '#B5401A';
      this.style.borderWidth = '2px';
      updateVariant();
    });
  });

  document.querySelectorAll('[data-pdp-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var body = this.parentElement.querySelector('[data-pdp-accordion-body]');
      var icon = this.querySelector('[data-pdp-accordion-icon]');
      if (expanded) {
        this.setAttribute('aria-expanded', 'false');
        if (body) body.style.maxHeight = '0';
        if (icon) icon.style.transform = 'rotate(0deg)';
      } else {
        this.setAttribute('aria-expanded', 'true');
        if (body) body.style.maxHeight = '800px';
        if (icon) icon.style.transform = 'rotate(45deg)';
      }
    });
  });

  document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = this.getAttribute('data-media-src');
      var mainImg = document.querySelector('[data-pdp-main-image] img');
      if (mainImg && src) { mainImg.setAttribute('src', src); mainImg.setAttribute('srcset', ''); }
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.style.opacity = '0.6'; t.style.borderColor = 'transparent';
      });
      this.style.opacity = '1'; this.style.borderColor = 'rgba(255,255,255,0.8)';
    });
  });

  var qtyMinus = document.querySelector('[data-pdp-qty-minus]');
  var qtyPlus = document.querySelector('[data-pdp-qty-plus]');
  var qtyDisplay = document.querySelector('[data-pdp-qty-display]');
  var qtyInput = document.querySelector('[data-pdp-qty-input]');
  if (qtyMinus && qtyPlus && qtyDisplay && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10);
      if (val > 1) { qtyInput.value = val - 1; qtyDisplay.textContent = val - 1; }
    });
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10);
      qtyInput.value = val + 1; qtyDisplay.textContent = val + 1;
    });
  }
})();
